<template>
    <button
        :class="[
            { 'odd-multiple-button--locked': isLocked },
            { 'odd-multiple-button--selected': isSelected },
        ]"
        @click="$emit('click', $event)"
        class="odd-multiple-button sds-focus"
    >
        <SdsIcon
            v-if="isLocked"
            iconName="toggle-lock"
            size="sm"
            class="odd-multiple-button__locked-icon"
        />

        <SdsIcon
            v-else
            iconName="commerce-ticket-add"
            size="sm"
            class="odd-multiple-button__unlocked-icon"
        />

        <span class="odd-multiple-button__text">
            {{ $t(oddMultipleButtonText) }}
        </span>
    </button>
</template>

<script>
    import { SdsIcon } from '@superbet-group/web.lib.ui-components';
    import { defineComponent } from '@vue/composition-api';
    export default defineComponent({
        name: 'OddMultipleButton',
        emits: [
            'click',
        ],
        props: {
            isLocked: {
                type: Boolean,
                required: true,
            },
            isSelected: {
                type: Boolean,
                required: false,
                default: false,
            },
            oddMultipleButtonText: {
                type: String,
                required: false,
                default: '',
            },
        },
        components: {
            SdsIcon,
        },
    });
</script>

<style lang="scss" scoped>
    @import '~@superbet-group/web.lib.global-styles/type';

    .odd-multiple-button {
        $omb: &;

        display: flex;
        align-items: center;
        gap: 8px;
        height: 32px;
        margin: 0;
        padding: 0 16px;
        background-color: var(--system-bg-elevation-layer-2);
        border: var(--stroke-default) solid var(--system-border-on-elevation-secondary);
        border-radius: 5px;
        font-family: var(--system-label-default-bold-family);
        font-size: var(--system-label-default-bold-size);
        font-weight: $font-weight-medium;
        line-height: var(--system-label-default-bold-line-height);
        letter-spacing: var(--system-label-default-bold-letter-spacing);
        color: var(--system-text-on-elevation-primary);
        cursor: pointer;

        &:where(:not(#{$omb}--locked)) {
            &:hover,
            &:focus-visible {
                background-color: var(--system-bg-elevation-layer-2-hover);
            }
        }

        &--locked {
            color: var(--system-text-on-elevation-disabled);
            cursor: not-allowed;
        }

        &--selected {
            background-color: var(--component-button-primary-bg);
            border-color: var(--component-button-primary-bg);
            color: var(--component-button-primary-text);

            &:where(:not(#{$omb}--locked)) {
                &:hover {
                    background: var(--component-button-primary-bg-hover);
                }
            }
        }
    }

</style>
